<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
      <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.code"> -->
  <vx-card no-radius no-shadow class="grid-view-item mb-base overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <div class="absolute bg-success px-10 py-2 text-white text-bold text-center" style="width: 200px; top: -8px; left: -52px; transform: rotate(-45deg);" v-show="onSale">PROMOCIÓN<br/><b>Antes Q{{ item.originalPrice }}</b></div>

      <!-- ITEM IMAGE -->
      <div class="item-img-container bg-white flex items-center justify-center mt-8 mb-2 cursor-pointer" style="height: 20rem;" @click="viewImage">
        <vx-tooltip position="left" :title="item.name" :text="item.description" class="flex flex-col items-center justify-center">
<!--          <img :src="getImage(item)" :alt="item.name" class="grid-view-img" rel="preload">-->
          <img :src="getImage(item, imageHeight)" :alt="item.name" class="mx-auto" rel="preload">
          <!--
                    <cld-image
                      :cloudName="cloudName"
                      :publicId="`products/${item.id}/${item.isbn}.png`"
                      width="auto"
                      :height="imageHeight"
                    />
          -->
          <h4 class="m-2">{{ item.name }}</h4>
        </vx-tooltip>
      </div>
      <div class="item-details px-4">

        <!-- RATING & PRICE -->
        <!--                        <div class="flex justify-between items-center">-->
        <!--                            <div class="text-warning border border-solid border-warning flex py-1 px-2 rounded">-->
        <!--                                <span class="text-sm mr-1">{{ item.rating }}</span>-->
        <!--                                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" />-->
        <!--                            </div>-->
        <!--                            <h6 class="font-bold">Q{{ item.price }}</h6>-->
        <!--                        </div>-->

        <!-- TITLE & DESCRIPTION -->
        <!--                        <div class="items-center justify-center my-4">-->
        <!--                            <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer" @click="viewImage">{{ item.name }}</h6>-->
        <!--                        </div>-->
      </div>

      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons"/>
    </template>
  </vx-card>
  <!--  </div>
</div> -->
</template>

<script>
  // import {CldImage} from 'cloudinary-vue';

  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
/*
    components: {
      CldImage
    },
*/
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      imageHeight() {
        if (this.windowWidth < 992) {
          return 150;
        } else {
          return 220;
        }
      },
      cloudName() {
        return this.$store.getters['getParameter']('cloudinary').cloudName;
      },
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      onSale() {
        if (this.item.hasOwnProperty('onSale')) {
          return this.item.onSale;
        } else {
          return false;
        }
      }
    },
    methods: {
      viewImage() {
        this.$router.push({name: 'item-detail-view', params: {item: this.item.id}}).catch(() => {});
      },
      getImage(item, height) {
        const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.png?alt=media'].join('');
        return imageURL;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
